import axios from "axios";
import React, { FormEvent, useState } from 'react';
import classNames from 'classnames';
import { useNavigate} from "react-router-dom";

import { Button } from "../Button";
import { ProfileIcon, HashtagIcon, Arrow } from "../../assets/icons";
import { API_URL, USER_ROLE } from "../../constants";
import { USER_ROLE_ENUM } from "../../types";
import { LoginRoleContent } from "../../content/login";

import './styles.scss';

interface LoginFormProps {
  content: LoginRoleContent,
  userRole: USER_ROLE_ENUM,
}

export const LoginForm: React.FC<LoginFormProps> = ({
  content,
  userRole
}) => {
  const APP_API_URL = API_URL || process.env.REACT_APP_API_URL || "http://localhost:8000";
  const navigate = useNavigate(); // To navigate between routes
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loggedUserData, setLoggedUserData] = useState();
  const isNotStudent = userRole !== USER_ROLE.student;

  const onEmailChange = (value: string) => {
    setError('');
    setEmail(value);
  }

  const onPasswordChange = (value: string) => {
    setError('');
    setPassword(value);
  }

  const fetchUserData = async (role: USER_ROLE_ENUM) => {
    setError('');
    let userData: any = { email: email };

    if (role === USER_ROLE_ENUM.student) {
      userData = { name: email };
    }
    try {
      const response = await axios.post(`${APP_API_URL}/login/${role}`, {
        ...userData, password: password
      }, { withCredentials: true });

      if (response.status === 400) {
        console.log('response.status', response.status);
        console.log('response', response);
      }

      return response.data;
    } catch (e: any) {
      console.log("Error while fetching data", e);
      setError(e.response.data.message);
    }
  };

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    //TODO: add login error handling
    if (!email.length || !password.length) {
      setError('Fill in all the fields');
    } else {
      const userData = await fetchUserData(userRole);
      if (!!userData?.userId) {
        const { userId } = userData;
        localStorage.setItem('userId', JSON.stringify(userData));

        setLoggedUserData(userData);
        if (userRole === USER_ROLE.student) {
          navigate(`/river-map/`, { state: { user: loggedUserData }});
          window.history.pushState(null, '', window.location.href)
        }
        if (userRole === USER_ROLE.teacher) {
          navigate(`/teacher-dashboard/`, { state: { user: loggedUserData }});
        }
        if (userRole === USER_ROLE.admin) {
          navigate(`/admin-dashboard/`, { state: { user: loggedUserData }});
        }
      } else {
        setError('Invalid email or password');
      }
    }
  };

  return (
    <div className={classNames("FormContainer", {
      "isNotStudent": isNotStudent,
    })}>
      {isNotStudent && <h1>{content.FORM_TITLE}</h1>}
      <form className="Form" onSubmit={handleLogin} noValidate>
        <div className="InputContainer">
          {isNotStudent && <label htmlFor="email" className="InputLabel">{content.NAME_FIELD_TITLE}</label>}
          <input
            id="email"
            type="text"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            required
            placeholder={content.NAME_FIELD_PLACEHOLDER}
            autoComplete="on"
            className={classNames("InputField", {
              "ErrorState": error,
            })}
          />
          <ProfileIcon className="InputFieldIcon"/>
        </div>
        <div className="InputContainer">
          {isNotStudent && <label htmlFor="password" className="InputLabel">{content.PASSWORD_FIELD_TITLE}</label>}
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            required
            placeholder={content.PASSWORD_FIELD_PLACEHOLDER}
            className={classNames("InputField", {
              "ErrorState": error,
            })}
          />
          <HashtagIcon className="InputFieldIcon"/>
          {error && <p className="ErrorMessage">{error}</p>}
        </div>
        <Button className="SubmitBtn">
          <Arrow className="RightArrowIcon"/>
        </Button>
      </form>
    </div>
  );
};
